import { useRef } from "react";
import _ from "lodash";

export function useStableValue<T>(value: T) {
  const ref = useRef<T>(value);

  if (!_.isEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
}
